<template>
    <span>
        <v-dialog max-width="600px">
        <span column slot="activator" class="fab-container">
            <v-btn fab  dark large color="brown darken-4" fixed right bottom><v-icon>person_add</v-icon></v-btn>
        </span>
         <v-card
          flat
          class="flex"
         >
             <v-card-title primary-title>
                <h1 class="headline mb-1"><b>ADD NEW REFRESHMENT</b></h1>

             </v-card-title>
              
             <v-card-text class=" text-xs-center display-1  my-2 flex">
                
                
             </v-card-text>
             <v-card-text>
                <v-form class="px-3" ref="form"> 
                     <v-text-field label="Refreshment Name*" v-model="name" @keypress="isName" :rules="nameRules" prepend-icon="comment"></v-text-field>
                     <v-text-field label="Refreshment Price*" v-model="price" @keypress="isNumber" :rules="priceRules" prepend-icon="money"></v-text-field>
                     <span> * indicates required field </span>
                </v-form>
             </v-card-text>
             <v-divider></v-divider>
              <v-card-actions>
                <v-btn outline block color="brown" @click="add()" :disabled="isDisabled" :loading="isDisabled">Add Refreshment</v-btn>
             </v-card-actions>
         </v-card>
        </v-dialog>
   </span>
</template>

<script>
import {addModule} from '@/model';
import moment from 'moment';

export default {
    name: 'AddStaff',
    data() {
        return {
         isDisabled:false,
         name:'',
         price:'',
         nameRules:[
               v => v.length >=2  || "Minimum length is 3 characters",
               v => v.length <=30  || "Maximum length is 20 characters" 
           ],
        priceRules:[
               v => v.length >=2  || "Minimum length is 2 characters",
               v => v.length <=30  || "Maximum length is 5 characters" 
           ]

        };
    },
    methods: {
        isName:function(evt){
            evt = (evt) ? evt : window.event;
            let charcode = (evt.which) ? evt.which : evt.keycode;
            if((charcode > 31 && (charcode < 48 || charcode > 57)) && charcode !== 32 && charcode !== 46){
                return true;
            }else{
                evt.preventDefault();
            }
        },
        isNumber:function(evt){
            evt = (evt) ? evt : window.event;
            let charcode = (evt.which) ? evt.which : evt.keycode;
            if((charcode > 31 && (charcode < 48 || charcode > 57)) || charcode == 46){
                evt.preventDefault();
            }else{
                return true;
            }
        },
        add() {
            let self=this;
            if(this.$refs.form.validate()){
            let datenow = moment().format('DD/MM/YYYY');
            
            let useradd = this.$store.getters.getStaff.name;
            console.log(useradd); 
            
            let newitem = {name:this.name.toLowerCase(),price:this.price,dateadded:datenow,useradd:useradd};
            console.log(newitem);
            self.isDisabled = true;
            
              addModule('refreshment',this.name.toLowerCase(),newitem,function(response){
                  if(response){
                      console.log("This is response: ",response);
                      alert('Refreshment has been successfully added');
                      self.isDisabled = false;
            
                      self.$store.dispatch('updateRefreshments');
                  }else{
                      self.isDisabled = false;
            
                      console.log("Unknown Error occured.");
                  }

               })
            }
        }
    }
};
</script>

<style scoped>
</style>